var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":"","outlined":""}},[_c('v-card-title',[_vm._v("Exams")]),_c('v-card-text',[_c('ExamsList')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }